import SearchPanel from './SearchPanel';
import AdvancedContainer from './AdvancedContainer';
import HeadContainer from './HeadContainer';

SearchPanel.HeadContainer = HeadContainer; 
SearchPanel.AdvancedContainer = AdvancedContainer;

export default SearchPanel;


// WEBPACK FOOTER //
// ./src/index.js